import { Button } from "@blueprintjs/core"
import { useState } from "react"
import { NAVIGATION_THEME_TYPE } from "src/libs/useful/gallery/Gallery"
import { ICWProps, NAV_THEMES } from "."

/* Protopia Ecosystem component */ 
const NavThemeHandler = (props: ICWProps): JSX.Element => {
    const [ values, ] = useState<NAVIGATION_THEME_TYPE[]>( Object.values( NAVIGATION_THEME_TYPE).map( val => val ) )
    const onChange = () => {
        const index = values.findIndex(v => v ===  props.carousel_nav_theme) || 0
        const next = ( index + 1 ) % values.length
        props.onChange( {
            ...props,
            carousel_nav_theme: values[next] 
        })
    }
    return <>
         <Button variant="minimal" size="small" className="btn-stretch p-0" onClick={onChange} >
            <div 
                className="small"
                style={{
                    width: 35,
                    height: 25,
                    backgroundColor: NAV_THEMES[ props.carousel_nav_theme || NAVIGATION_THEME_TYPE.DEFAULT ],
                    border: "1px dotted var(--force-contrast-opacity-color)"
                }}
            />
        </Button> 
    </>
}
export default NavThemeHandler